import {SlButton, SlDialog, SlIcon, SlInput} from '@shoelace-style/shoelace/shoelace';
import {notNull} from '../../../../vendor/plugins/clxMobileNetPortable/assets/responsive/js/common/assert';
import {HeaderHeightCalculator} from '../../../../vendor/plugins/clxMobileNetPortable/assets/responsive/js/components/headerHeightCalculator';
import {ScrollToElement} from '../common/scrollToElement';

/**
 * in phone wird die Adresseingabe in einem Layer durchgefuehrt
 */
export class InternetAddressLayer {
    private readonly viewRoot: HTMLElement;

    constructor(viewRoot: HTMLElement) {
        this.viewRoot = viewRoot;

        const addressDialog = document.querySelector('.dsl-address-dialog') as SlDialog;

        if (addressDialog) {
            this.initialize(addressDialog);
        }
    }

    private setNoScroll(noScroll: boolean): void {
        const rootElement = notNull(document.querySelector('html'));
        if (noScroll) {
            rootElement.classList.add('sl-scroll-lock');
        } else {
            rootElement.classList.remove('sl-scroll-lock');
        }
    }

    private setRequiredOrNot(): void {
        const mobileAddressField = document.querySelector('#mobile-address-field') as SlInput;
        if (!mobileAddressField) {
            return;
        }

        // nur in phone ein pflichtfeld
        if (window.innerWidth < 767) {
            mobileAddressField.setAttribute('required', '');
        } else {
            mobileAddressField.removeAttribute('required');
        }
    }

    private stringifyInput(dialogFields: NodeListOf<SlInput>): void {
        const mobileAddressField = document.querySelector('#mobile-address-field') as SlInput;

        if (!mobileAddressField) {
            return;
        }
        let addressString = '';

        dialogFields.forEach((dialogField) => {
            if (typeof dialogField.value !== 'undefined') {
                addressString = `${addressString} ${dialogField.value}`;
            }
        });
        mobileAddressField.value = addressString.replace(/^\s+|\s{2,}|\s+$/g, '');
    }

    private initialize(addressDialog: SlDialog): void {
        const mobileAddressField = document.querySelector('#mobile-address-field') as SlInput;
        const dialogFields = addressDialog.querySelectorAll<SlInput>('sl-input');
        const dialogFieldsRequired = addressDialog.querySelectorAll<SlInput>('sl-input.mobile-required');

        if (!mobileAddressField || dialogFields.length === 0 || dialogFieldsRequired.length === 0) {
            return;
        }

        const resizeObserver = new ResizeObserver(() => this.setRequiredOrNot());
        resizeObserver.observe(document.body);

        this.stringifyInput(dialogFields);

        dialogFields.forEach((dialogField: SlInput) => {
            dialogField.addEventListener('sl-change', (event: Event) => {
                const elementName = dialogField.name;
                const elementValue = dialogField.value;

                const fieldsToFill = document.querySelectorAll(`[name="${elementName}"]`) as NodeListOf<SlInput>;

                fieldsToFill.forEach((fieldToFill) => {
                    fieldToFill.value = elementValue;
                });
            });
        });

        addressDialog.addEventListener('sl-hide', () => {
            this.setNoScroll(false);
        });

        mobileAddressField.addEventListener('click', () => {
            dialogFieldsRequired.forEach((dialogFieldRequired) => {
                dialogFieldRequired.setAttribute('required', '');
            });

            addressDialog.show();

            this.setNoScroll(true);

            const closeButtonTopRight = notNull(addressDialog.querySelector('.address-close')) as SlIcon;
            closeButtonTopRight.addEventListener('click', () => {
                dialogFields.forEach(() => {
                    mobileAddressField.value = '';
                });
                addressDialog.hide();

                const form = mobileAddressField.closest<HTMLElement>('.form');
                if (form) {
                    new ScrollToElement(form);
                }
            });
        });

        const closeButton = notNull(addressDialog.querySelector('sl-button') as SlButton);
        closeButton.addEventListener('click', () => {
            dialogFieldsRequired.forEach((dialogFieldRequired: SlInput) => {
                const dialogFieldRequiredValue = dialogFieldRequired.value.replace(/\s/g, '');

                if (dialogFieldRequiredValue === '') {
                    dialogFieldRequired.setCustomValidity('Dieses Feld ist erforderlich');
                    dialogFieldRequired.setAttribute('data-user-invalid', '');
                } else {
                    dialogFieldRequired.setCustomValidity('');
                    dialogFieldRequired.removeAttribute('data-user-invalid');
                }
            });

            this.stringifyInput(dialogFields);

            let valid = true;
            dialogFields.forEach((dialogField: SlInput) => {
                if (!dialogField.validity.valid) {
                    valid = false;
                }
            });

            if (valid) {
                addressDialog.hide();
                const form = mobileAddressField.closest<HTMLElement>('form');
                if (form) {
                    new ScrollToElement(form);
                }
            }
        });
    }
}
